import React, { createContext, useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageContext = createContext(undefined);

export const LanguageProvider = ({ children }) => {
  const { i18n, t, ready } = useTranslation();

  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('appLanguage');
    return saved || 'ru';
  });

  const changeLanguage = (lang) => {
    localStorage.setItem('appLanguage', lang);

    if (i18n && typeof i18n.changeLanguage === 'function') {
      i18n.changeLanguage(lang);
    }

    setLanguage(lang);

    if (typeof document !== 'undefined') {
      document.documentElement.lang = lang;
    }
  };

  useEffect(() => {
    if (!ready) return;
    const savedLanguage = localStorage.getItem('appLanguage');

    if (savedLanguage && savedLanguage !== language) {
      if (i18n && typeof i18n.changeLanguage === 'function') {
        i18n.changeLanguage(savedLanguage);
      }
      if (typeof document !== 'undefined') {
        document.documentElement.lang = savedLanguage;
      }
      setLanguage(savedLanguage);
    } else if (!savedLanguage) {
      const browserLang = typeof navigator !== 'undefined' ? navigator.language.split('-')[0] : 'ru';
      const supportedLanguages = ['en', 'ru'];

      const langToUse = supportedLanguages.includes(browserLang) ? browserLang : 'ru';
      changeLanguage(langToUse);
    }
  }, [i18n, ready]);

  const contextValue = {
    language,
    changeLanguage,
    isRussian: language === 'ru',
    supportedLanguages: ['en', 'ru']
  };

  return (
    <LanguageContext.Provider value={contextValue}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);

  if (context === undefined) {
    throw new Error('Language context is not available');
  }

  return context;
};

export default LanguageContext;